"use client";

import Cookies from "js-cookie";

import { SECONDARY_OFFER_COOKIE_NAME } from "@shared/constants";

import { throwUndefinedVariable } from "@shared/functions/throwError";

export default function deleteSecondaryOffersCookie() {
  if (!SECONDARY_OFFER_COOKIE_NAME) {
    throwUndefinedVariable("SECONDARY_OFFER_COOKIE_NAME");
  }

  Cookies.remove(SECONDARY_OFFER_COOKIE_NAME);
}
